import { ReqX } from "IZOX/STATIC";
import ReqConfig from "__SYSDefault/_ReqConfig";
import SysAPI from "./SysAPI";

class AtthExpress {

  static async Upload(files, onUploadProgress, remarks = ""){
    let res = await ReqX.SendBEWithAttachments(SysAPI.Blob.Upload, 
      {
        [ReqConfig.AttachmentFieldKey]: files,
        remarks: remarks
      }, null, null, undefined, false, false, {
        onUploadProgress
      });
    return {Success: res.Success, payload: res?.payload?.[ReqConfig.AttachmentFieldKey]};
  }

  static async GetBlobUrl(refID){
    let res = await ReqX.SendBE(SysAPI.Blob.GetUrl, 
      {
        refID: refID
      });
    return {
      url: res.payload
    };
  }

  static async GetBlobNoAuth(refID){
    return this.GetBlob(refID, SysAPI.Blob.GetBlobNoAuth);
  }

  static async GetBlob(refID, _api = SysAPI.Blob.GetBlob){
    let res = await ReqX.SendBEAndGetBlob(_api, 
      {
        refID: refID
      });

    let {Success, blob, payload} = res;

    try{
      let url = URL.createObjectURL(blob);
      let type = res.blob?.type;

      if(Success){
        return {
          Success,
          url,
          blob,
          type
        };
      }else{
        return {
          Success,
          payload,
          url: ""
        };
      }
    }catch{
      return {
        Success: false,
        payload: "",
        url: ""
      };
    }
    
  }

  static async Delete(refID){
    let res = await ReqX.SendBEAndGetBlob(SysAPI.Blob.Delete, 
      {
        refID: refID
      });
    return res;
  }

}

export default AtthExpress;